
import { Moment } from 'moment';

export class SituacaoEntidadeSuspensaVO {

  idSituacaoEntidade: number;
  dataSuspensao: Moment;
  nrPortaria: number;
  dataPublicacaoPortaria: Moment;

}
